<script>
/**
 * Mixin for filter and sorting options of meeting-infos.vue
 */

export default {

  computed: {
    /** Array: Sorting options */
    infosSortingOptions() {
      return [
        {
          key: 'infosOptDisplayFullInfo',
          value: this.infosOptDisplayFullInformation,
          component: 'Checkbox',
          options: {
            title: this.$t('message.INFO_DISPLAY_FULL_INFO')
          },
        },
        {
          key: 'infosOptSortTitle',
          value: '',
          component: 'h2',
          options: {
            class: 'mt5em mb5em basic-sub-title',
          },
          slots: [{
            component: 'Div',
            content: this.$t('message.SORT'),
          }],
        },
        {
          key: 'infosSortBy',
          value: this.infosOptSortBy,
          component: 'RadioGroup',
          options: {
            sortable: true,
            items: this.infosOptSortByItems,
          },
        },
      ];
    },
    /** Array: All options including filters and sorting */
    infosOptions() {
      return [
        ...this.infosSortingOptions,
        {
          key: 'infosOptFiltersTitle',
          component: 'h2',
          options: {
            class: 'mt5em mb5em basic-sub-title',
          },
          slots: [{
            component: 'Div',
            content: this.$t('message.FILTERS'),
          }],
        },
        {
          key: 'infosDefaultViewMode',
          component: 'EditableLabelRadio',
          value: this.infosOptDefaultViewMode,
          options: {
            class: 'mb10em',
            legend: this.$t('message.DEFAULT_DISPLAY') + this.$t('message.TWO_DOTS'),
            items: this.infosOptViewModes,
            labelKey: 'label',
            grayLegend: true,
          },
        },
      ];
    },
    /** Object: Selected sorting option */
    infosOptDisplayFullInformation() {
      if (this.allPageOptions && this.allPageOptions.infosOptDisplayFullInfo) {
        return this.allPageOptions.infosOptDisplayFullInfo;
      }
      return false;
    },
    /** Array: Items for the sorting options */
    infosOptSortByItems() {
      return [
        { id: 0, label: this.$t('message.INFO_RELEASE_DATE') },
        { id: 1, label: this.$t('message.INFO_REMOVAL_DATE') },
      ];
    },
    /** Object: Selected sorting option */
    infosOptSortBy() {
      if (this.allPageOptions && this.allPageOptions.infosSortBy) {
        return this.allPageOptions.infosSortBy;
      }
      return { value: this.infosOptSortByItems[0].id, desc: false };
    },
    /** Number: Selected id of the default view mode */
    infosOptDefaultViewMode() {
      if (this.allPageOptions && this.allPageOptions.infosDefaultViewMode !== undefined) {
        return Number(this.allPageOptions.infosDefaultViewMode);
      }
      return 0;
    },
    /** Number: Selected id of the default view mode */
    infosOptViewModes() {
      return [
        { id: 0, label: this.$t('message.TEAM_INFOS'), short: this.$t('message.TEAM_INFOS_SHORT') },
        { id: 1, label: this.$t('message.SENT_INFOS'), short: this.$t('message.SENT_INFOS_SHORT') },
        { id: 2, label: this.$t('message.UPCOMING_INFOS'), short: this.$t('message.UPCOMING_INFOS') },
      ];
    },
    /** Array: Modes for switcher titles */
    infosOptViewModeLabels() {
      return this.infosOptViewModes.map(mode => mode.short);
    },
    /** Array: Hints for switcher */
    infosOptViewModeHints() {
      return this.infosOptViewModes.map(mode => mode.label);
    },
  },

  methods: {
    /** Create a string formatted as query params with infosOptions params */
    infosOptQueryParams(options) {
      if (!options) {
        return '';
      }
      let query = '';
      let amp = '';
      if (options.infosOptDisplayFullInfo) {
        query += `infosOptDisplayFullInfo=${options.infosOptDisplayFullInfo ? 'true' : 'false'}`;
        amp = '&';
      }
      if (options.infosSortBy) {
        query += `infosSortBy=${options.infosSortBy.value}&infosSortDesc=${options.infosSortBy.desc}`;
        amp = '&';
      }
      if (options.infosDefaultViewMode !== undefined) {
        query += `${amp}infosDefaultViewMode=${options.infosDefaultViewMode}`;
        amp = '&';
      }
      return query;
    },
  },
};
</script>
